import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { useTrackers } from '@ps/web-shared-analytics';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

import { select } from '@swf/core/store';

import Default from './components/Default/Default';
import SportsMaintenance from './components/SportsMaintenance/SportsMaintenance';

const ServiceUnavailable: React.FC<RouteComponentProps> = ({ staticContext }) => {
  const { errorViewed } = useTrackers();
  const isSports = useSelector(select.sports.isSports);
  const brandId = useSelector(select.cms.getBrandId);

  useEffect(() => errorViewed({ errorCode: 'SYSTEM_UNAVAILABLE' }), [errorViewed]);

  if (staticContext) {
    staticContext.statusCode = 503;
  }

  if (brandId === BrandTypes.BET_STARS || isSports) {
    return <SportsMaintenance />;
  }
  return <Default />;
};

export default withRouter(ServiceUnavailable);
